const genericValidator = (fieldName, value, validations = {}) => {
    const {
        required = false,
        minLength = 0,
        maxLength = 0,
        pattern = null,
    } = validations;

    if (required && !value) {
        return { type: 'required', message: `${fieldName} is required` };
    } else if (!value) {
        return { type: null, message: null };
    }

    if (minLength && value.length < minLength) {
        return {
            type: 'minLength',
            message: `${fieldName} must be at least ${minLength} characters`,
        };
    }

    if (maxLength && value.length > maxLength) {
        return {
            type: 'maxLength',
            message: `${fieldName} must be less than ${maxLength} characters`,
        };
    }

    if (pattern && !pattern.test(value)) {
        return {
            type: 'pattern',
            message: `${fieldName} contains invalid characters`,
        };
    }
    return { type: null, message: null };
};

// Luhn checksum used by both IMEI and ICCID
export function luhnCheck(digits) {
    const s = digits.replace(/\D/g, '');
    if (s.length === 0) return false;

    let sum = 0;
    let doubleIt = false;
    for (let i = s.length - 1; i >= 0; i--) {
        let d = parseInt(s[i], 10);
        if (isNaN(d)) return false;
        if (doubleIt) {
            d *= 2;
            if (d > 9) d -= 9;
        }
        sum += d;
        doubleIt = !doubleIt;
    }
    return sum % 10 === 0;
}

// IMEI validator (15 digits, must pass Luhn)
export function isValidIMEI(input) {
    if (!input) return false;
    const s = input.replace(/[\s-]/g, '');
    if (!/^\d{15}$/.test(s)) return false;
    return luhnCheck(s);
}

// ICCID validator (19–20 digits, starts with 89)
export function isValidICCID(input, opts = {}) {
    const { requirePrefix89 = true, allowedLengths = [19, 20] } = opts;
    if (!input) return false;
    const s = input.replace(/[\s-]/g, '');
    if (!/^\d+$/.test(s)) return false;
    if (requirePrefix89 && !s.startsWith('89')) return false;
    if (!allowedLengths.includes(s.length)) return false;
    return luhnCheck(s);
}

// Mantine-friendly validators (return null if valid, error string otherwise)
export function validateIMEIForMantine(value) {
    if (!value || value.trim() === '') return 'IMEI is required';
    if (!isValidIMEI(value))
        return 'Invalid IMEI — must be 15 digits and pass checksum';
    return null;
}

export function validateICCIDForMantine(value, opts = {}) {
    if (!value || value.trim() === '') return 'ICCID is required';
    if (!isValidICCID(value, opts)) {
        const lengths = (opts.allowedLengths || [19, 20]).join(' or ');
        const prefixMsg =
            opts.requirePrefix89 === false ? '' : ' and should start with "89"';
        return `Invalid ICCID — must be ${lengths} digits${prefixMsg} and pass checksum`;
    }
    return null;
}

export { genericValidator };
